"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.resources = void 0;
var resources;
(function (resources) {
    resources["aps"] = "aps";
    resources["background_screen"] = "background_screen";
    resources["eligibility_override"] = "eligibility_override";
    resources["fifa_integration"] = "fifa_integration";
    resources["fifa_status"] = "fifa_status";
    resources["membership"] = "membership";
    resources["membership_definition"] = "membership_definition";
    resources["proof_of_birth"] = "proof_of_birth";
    resources["safesport"] = "safesport";
    resources["sideline_sports"] = "sideline_sports";
    resources["violation_review"] = "violation_review";
    resources["waiver_acceptance"] = "waiver_acceptance";
    resources["waiver"] = "waiver";
})(resources = exports.resources || (exports.resources = {}));
